import React from "react";
import "./TextImage.css";

function TextImage({ header, text, image, extra }) {
  return (
    <div className="text-image-container">
      <div className="text">
        <h1>{header}</h1>
        <p>{text}</p>
        {extra}
      </div>
      <img src={image} alt={header} />
    </div>
  );
}

export default TextImage;
